import momentTimezone from 'moment-timezone';

import { DDMMYYYYTimeFormat } from '../../../../util/GlobalConstant';
import { getDownloadTimezone } from '../../../../util/timezone';

/**
 * FIN-12993 — render the CRS Transaction Details date in the SAME timezone the
 * CSV export uses, so the grid and the download can never disagree.
 *
 * The export runs `CONVERT_TZ(transaction_date, 'UTC', :zoneId)` with
 * `zoneId = getDownloadTimezone()`, so rendering the same conversion here makes
 * the two equal by construction, in every browser timezone and under both
 * `download-timezone-mode` settings:
 *
 *   mode 'utc'     -> both sides stay on the raw stored wall-clock
 *   mode 'browser' -> both sides shift to the viewer's zone
 *
 * `time-adjustment` is deliberately NOT applied. It exists to undo the
 * browser-local conversion for tenants whose data is stored as local
 * wall-clock labelled UTC; this formatter never does that conversion for them
 * (mode 'utc' keeps the value in UTC), so re-applying the offset would shift
 * the grid off the export. The previous inline
 * `moment.utc(v).local().format('DD/MM/YYYY')` did do the conversion, without
 * the offset, which is what put the grid up to a whole day off the CSV.
 */
export const formatTransactionDate = (row) =>
  row.transactionDate
    ? momentTimezone
        .utc(row.transactionDate)
        .tz(getDownloadTimezone())
        .format(DDMMYYYYTimeFormat)
    : '-';
